import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import DOMPurify from "dompurify";
import { SEOHead } from "@/components/SEOHead";

export default function Terms() {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchPolicy();
  }, []);
  const fetchPolicy = async () => {
    const {
      data
    } = await supabase.from("site_policies").select("*").eq("policy_type", "terms").single();
    if (data) {
      setContent(data.content);
    }
    setLoading(false);
  };
  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>;
  }
  return <div className="space-y-6 animate-fade-in max-w-4xl mx-auto">
      <SEOHead slug="terms" />
      <div>
        <h1 className="text-3xl font-bold text-foreground">Terms of Service</h1>
        <p className="text-muted-foreground mt-2">Last updated: {new Date().toLocaleDateString()}</p>
      </div>

      <Card className="shadow-card">
        <CardHeader>
          
        </CardHeader>
        <CardContent className="prose prose-slate dark:prose-invert max-w-none">
          <div dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(content, {
            ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'blockquote', 'div', 'span'],
            ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style']
          })
        }} />
        </CardContent>
      </Card>
    </div>;
}